<template>
<div id="app">

  <transition name="fade" mode="out-in">
    <router-view />
  </transition>

</div>
</template>

<script>

import {onPageLoadEvent, oaga} from '@oa-shared-components/oa-fe-ga-library';

export default {
  name: 'SmartSearch',
  components: {
  },
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {
    oaga({
      page: 'smart-search',
    });
  }
};
</script>

<style lang="scss">
@import 'assets/styles/app';

#app {
    font-family: Lato;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
